import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useIsOrgVqaOnly } from "../../utils/vqaOnlyOrg";

function DefaultIdeas({ onSuggestionClick }) {
  const isVqaOnly = useIsOrgVqaOnly();
  const allSuggestions = [
    {
      title: "Innovation",
      description: "List out the top innovative vendors on the platform",
      category: "General",
    },
    {
      title: "CRO Experience",
      description:
        "Give me a list of CROs with experience in Parkinson's trials",
      category: "Clinical",
    },
    {
      title: "ECOA Providers",
      description:
        "Provide a list of the top ECOA providers with published VQQ content",
      category: "Technology",
      aboutVqqs: true,
    },
    {
      title: "Oncology Experience",
      description:
        "Give me a list of all vendors with Phase I oncology experience",
      category: "Therapeutic",
    },
  ];
  const suggestions = isVqaOnly
    ? allSuggestions.filter((suggestion) => !suggestion.aboutVqqs)
    : allSuggestions;

  const handleSuggestionClick = (suggestion) => {
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4">
      <div className="text-center mb-4">
        <h3 className="text-sm font-medium text-gray-900">Try asking about:</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => handleSuggestionClick(suggestion)}
            className="group text-left p-4 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{ borderColor: "rgb(229, 231, 235)" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#6036C4";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "rgb(229, 231, 235)";
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = "2px solid #6036C4";
              e.currentTarget.style.outlineOffset = "2px";
            }}
            onBlur={(e) => {
              e.currentTarget.style.outline = "none";
            }}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span
                    className="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium"
                    style={{ backgroundColor: "#e8e0f5", color: "#6036C4" }}
                  >
                    {suggestion.category}
                  </span>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 transition-colors group-hover:text-[#6036C4]">
                  {suggestion.title}
                </h4>
                <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                  {suggestion.description}
                </p>
              </div>
              <ChevronRightIcon className="h-4 w-4 text-gray-400 transition-colors flex-shrink-0 ml-2 group-hover:text-[#6036C4]" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default DefaultIdeas;
